import { render, staticRenderFns } from "./questionTypeDate.vue?vue&type=template&id=5c083434&scoped=true&"
import script from "./questionTypeDate.vue?vue&type=script&lang=js&"
export * from "./questionTypeDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c083434",
  null
  
)

export default component.exports